import "./__styles__/Icon.scss";
import React from "react";

const Remove = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 0C4.81331 0 3.65328 0.351894 2.66658 1.01118C1.67989 1.67047 0.910851 2.60754 0.456726 3.7039C0.00259972 4.80026 -0.11622 6.00665 0.115291 7.17054C0.346802 8.33443 0.918247 9.40352 1.75736 10.2426C2.59648 11.0818 3.66558 11.6532 4.82946 11.8847C5.99335 12.1162 7.19975 11.9974 8.2961 11.5433C9.39246 11.0891 10.3295 10.3201 10.9888 9.33342C11.6481 8.34673 12 7.18669 12 6C11.9954 4.41012 11.3618 2.88668 10.2375 1.76246C9.11332 0.63824 7.58988 0.00461698 6 0V0ZM8.475 7.768L7.768 8.475L6 6.707L4.232 8.475L3.525 7.768L5.293 6L3.525 4.232L4.232 3.525L6 5.293L7.768 3.525L8.475 4.232L6.707 6L8.475 7.768Z"
        fill="#D84D48"
      />
    </svg>
  );
};

export default Remove;
